import app from 'flarum/forum/app';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Navigation from 'flarum/common/components/Navigation';
import LinkButton from 'flarum/common/components/LinkButton';
import DefaultResolver from 'flarum/common/resolvers/DefaultResolver';
export { default as extend } from './extend';
app.initializers.add('sycho/flarum-private-facade', () => {
  // @ts-ignore
  const isPrivateFacadePage = () => ['sycho-private-facade.login', 'sycho-private-facade.signup'].includes(app.current.data.routeName);
  override(HeaderSecondary.prototype, 'view', function (orig) {
    if (isPrivateFacadePage() && ['show_only_logo', 'hide_secondary_items'].includes(app.forum.attribute('sycho-private-facade.header_layout'))) {
      return null;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return orig(...args);
  });
  override(HeaderPrimary.prototype, 'view', function (orig) {
    if (isPrivateFacadePage() && app.forum.attribute('sycho-private-facade.header_layout') === 'show_only_logo') {
      return null;
    }
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const original = orig(...args);
    if (isPrivateFacadePage() && original && app.forum.attribute('sycho-private-facade.primary_color_bg') && app.forum.attribute('sycho-private-facade.header_layout') !== 'show_header') {
      original.attrs['data-primary-background'] = true;
    }
    return original;
  });

  // @ts-ignore
  override(Navigation.prototype, 'getBackButton', function (orig) {
    if (isPrivateFacadePage()) {
      return null;
    }

    // @ts-ignore
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return orig(...args);
  });
  extend(HeaderSecondary.prototype, 'items', items => {
    if (items.has('logIn')) {
      items.setContent('logIn', m(LinkButton, {
        className: "Button Button--link",
        href: app.route('sycho-private-facade.login')
      }, app.translator.trans('core.forum.header.log_in_link')));
    }
    if (items.has('signUp')) {
      items.setContent('signUp', m(LinkButton, {
        className: "Button Button--link",
        href: app.route('sycho-private-facade.signup')
      }, app.translator.trans('core.forum.header.sign_up_link')));
    }
  });
  override(DefaultResolver.prototype, 'onmatch', function (orig, args, requestedPath, route) {
    const urlExclusions = app.forum.attribute('sycho-private-facade.url_exclusions');
    if (!app.session.user && app.forum.attribute('sycho-private-facade.force_redirect') && !app.forum.attribute('sycho-private-facade.route_exclusions').includes(this.routeName) && !urlExclusions.some(url => url.includes('*') ? new RegExp(url.replace(/\*/g, '.*').replace(/\//g, '\\/')).test(requestedPath) : url === requestedPath)) {
      return m.route.set(app.route('sycho-private-facade.login'));
    }
    return orig(args, requestedPath, route);
  });
});